import './cloud.css';

import BubbleTitle from '../../../../components/bubbleTitle/bubbleTitle';
import BackgroundImg from '../../../../components/backgroundImg/backgroundImg';
import CloudBackground from '../../../../assets/sectionBackgrounds/cloudBackground/cloudBackground';
import ToolCards from '../../../../components/toolCards/toolCards';
import WifiGlobe from '../../../../assets/icons/wifiGlobe/wifiGlobe';
import StorageIcon from '../../../../assets/icons/storageIcon/storageIcon';
import ScaleIcon from '../../../../assets/icons/scaleIcon/scaleIcon';
import ToolFlipCards from '../../../../components/toolFlipCards/toolFlipCards';

export default function Cloud({isMobile}) {
    return(
        <div>
            <div className="cloud-container">
                <BackgroundImg background={<CloudBackground/>}/>
                <div className="cloud-titles">
                    <BubbleTitle title={<h1>Secure Cloud Access <span>&</span> Reliable Data Storage</h1>}/>
                    <p>Cloud-based expense tracking, reporting, and forecasting that scales from one person to thousands.</p>
                </div>
                {isMobile ?
                <div className="cloud-cards-mobile">
                <ToolFlipCards flipQuantity={true} cardSize={true}
                                iconOne={<StorageIcon/>} iconTwo={<WifiGlobe/>} iconThree={<ScaleIcon/>}
                                titleOne='Durable storage' titleTwo='Global access, local performance' titleThree='Scalability & performance' 
                                barBool={true} barWidth={'80%'} barCenter={'auto'}
                                bulletPointsOne={['Trust us with your security']} bulletPointsTwo={['Your expenses anywhere']} bulletPointsThree={['We’ll handle your scaling infrasturcture']}
                                textContentBottomOne={'Your expense records, receipts, and attachments are stored with redundancy and proven durability. Automatic multi‑zone replication, encrypted backups, and point‑in‑time recovery protect against hardware failure and accidental deletion. Retention policies and configurable backup windows let you meet audit and compliance needs while ensuring recoverability.'}
                                textContentBottomTwo={'Access Expensable from any browser or mobile device with fast, responsive performance — even for remote teams. Geo‑distributed edge routing and regional application instances reduce latency, while CDN caching and intelligent API routing keep dashboards and receipt uploads snappy across time zones. Result: real‑time access to expense data with a locally responsive experience for employees worldwide.'}
                                textContentBottomThree={'Built to grow with your business — auto-scaling infrastructure handles transaction spikes, large import jobs, and heavy reporting workloads without slowing users down. Background processing for OCR, reporting, and forecasting scales independently from the UI so day‑to‑day workflows remain fast. Monitoring, horizontal scaling, and performance SLAs ensure predictable response times as data and user counts increase.'}
                                />
                </div>
                
                :
                
                <div className="cloud-cards">

                    <ToolCards
                    size={false} 
                    icon={<WifiGlobe/>}
                    title='Global access, local performance'
                    barBool={true}
                    barWidth={'24rem'}
                    barCenter={'auto'}
                    bulletPoints = {['Your expenses anywhere']}
                    textContentBottom='Access Expensable from any browser or mobile device with fast, responsive performance — even for remote teams. Geo‑distributed edge routing and regional application instances reduce latency, while CDN caching and intelligent API routing keep dashboards and receipt uploads snappy across time zones. Result: real‑time access to expense data with a locally responsive experience for employees worldwide.'/> 

                    <div className="offset-cloud-card">
                    <ToolCards 
                    size={false} 
                    icon={<StorageIcon/>}
                    title='Durable storage'
                    barBool={true}
                    barWidth={'24rem'}
                    barCenter={'auto'}
                    bulletPoints = {['Trust us with your security']}
                    textContentBottom='Your expense records, receipts, and attachments are stored with redundancy and proven durability. Automatic multi‑zone replication, encrypted backups, and point‑in‑time recovery protect against hardware failure and accidental deletion. Retention policies and configurable backup windows let you meet audit and compliance needs while ensuring recoverability.'/>    
                    </div>

                    <ToolCards 
                    size={false} 
                    icon={<ScaleIcon/>}
                    title='Scalability & performance'
                    barBool={true}
                    barWidth={'24rem'}
                    barCenter={'auto'}
                    bulletPoints = {['We’ll handle your scaling infrasturcture']}
                    textContentBottom='Built to grow with your business — auto-scaling infrastructure handles transaction spikes, large import jobs, and heavy reporting workloads without slowing users down. Background processing for OCR, reporting, and forecasting scales independently from the UI so day‑to‑day workflows remain fast. Monitoring, horizontal scaling, and performance SLAs ensure predictable response times as data and user counts increase.'/>    

                </div>}
            </div>
        </div>
    )
}